export const useBasicErrorMessage = (
    givenId: ComputedRef<string>,
    hasError: ComputedRef<boolean>
) => {
    const id = computed(() => {
        return hasError.value
            ? `basic-error-message-${givenId.value}`
            : undefined;
    });
    return {
        id,
    };
};
